import {
  ATTRIBUTE_DIMENSION_MODELS,
  CUSTOM_ATTRIBUTE_DIMENSION,
} from 'kanban/constants/reports';

// A selecao da aba Dimensoes e um valor so: a chave do eixo embutido/de etiqueta, ou
// "custom_attribute:<modelo>:<chave>" para um atributo personalizado do cartao ou do contato.
const SEPARATOR = ':';

export const encodeDimension = ({ attributeModel, attributeKey }) =>
  [CUSTOM_ATTRIBUTE_DIMENSION, attributeModel, attributeKey].join(SEPARATOR);

export const decodeDimension = value => {
  const [dimension, attributeModel, ...key] = String(value).split(SEPARATOR);
  if (dimension !== CUSTOM_ATTRIBUTE_DIMENSION) return { dimension: value };
  return { dimension, attributeModel, attributeKey: key.join(SEPARATOR) };
};

const MODEL_ICONS = {
  task_attribute: 'i-lucide-square-kanban',
  contact_attribute: 'i-lucide-user',
};

// Atributos de cartao e depois de contato, com o tipo de registro no nome ("Cidade (contato)").
export const buildAttributeDimensionOptions = (definitionsByModel, t) => {
  const records = {
    task_attribute: t('KANBAN.REPORTS.DIMENSION.RECORD_TASK'),
    contact_attribute: t('KANBAN.REPORTS.DIMENSION.RECORD_CONTACT'),
  };
  return ATTRIBUTE_DIMENSION_MODELS.flatMap(model =>
    (definitionsByModel(model) || []).map(definition => ({
      label: `${definition.attribute_display_name} (${records[model]})`,
      value: encodeDimension({
        attributeModel: model,
        attributeKey: definition.attribute_key,
      }),
      icon: MODEL_ICONS[model],
    }))
  );
};

// Parametros de GET /dimension; date_group_by so vai quando a tela o mostra (atributo de data).
export const dimensionRequestParams = (value, dateGroupBy = null) => {
  const { dimension, attributeModel, attributeKey } = decodeDimension(value);
  if (dimension !== CUSTOM_ATTRIBUTE_DIMENSION) return { dimension };
  const params = {
    dimension,
    attribute_model: attributeModel,
    attribute_key: attributeKey,
  };
  if (dateGroupBy) params.date_group_by = dateGroupBy;
  return params;
};
